import { render, staticRenderFns } from "./MaterialWarehouseinfo.vue?vue&type=template&id=20027c7e"
import script from "./MaterialWarehouseinfo.vue?vue&type=script&lang=js"
export * from "./MaterialWarehouseinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports